<template>
  <div class="pt-4 pb-3">
    <div class="mfilter-wrap">
      <div class="filter-left">
        <b-button @click="show = true" class="filter-button">
          FILTERS
          <b-icon-filter></b-icon-filter>
        </b-button>
        <b-sidebar
          id="sb-filter"
          title="FILTERS"
          backdrop
          shadow
          :visible="show"
          text-variant="light"
          body-class="sb-body"
        >
          <template>
            <div>
              <div class="container">
                <div
                  class="is-flex"
                  v-b-toggle="`collapse-nft`"
                  style="justify-content: space-between"
                >
                  <div>Your NFTs</div>
                  <div>
                    <b-icon-chevron-down></b-icon-chevron-down>
                  </div>
                </div>
              </div>
              <hr />
              <b-collapse visible id="collapse-nft" class="mt-2">
                <b-container>
                  <div
                    v-for="it in oNfts"
                    :key="it.value"
                    class="is-flex"
                    style="justify-content: space-between"
                  >
                    <div>
                      <b-form-group>
                        <b-form-checkbox v-model="oNftType[it.value]" switch>
                          <span>{{ it.text }}</span>
                        </b-form-checkbox>
                      </b-form-group>
                    </div>
                  </div>
                </b-container>
              </b-collapse>
            </div>
          </template>
          <template #footer="{ hide }">
            <div class="fsider-bar d-flex justify-content-center py-2">
              <b-button class="btn-custom btn-cancel mr-2 px-4" @click="hide">
                Close
              </b-button>
              <b-button class="ml-2 btn-custom btn-success" @click="onApply">
                Apply
              </b-button>
            </div>
          </template>
        </b-sidebar>

        <div class="w-100 d-flex flex-row">
          <b-form-select
            class="sort w-100"
            v-model="myType"
            :options="sNft"
            @change="onApply"
            plain
          >
          </b-form-select>
        </div>

        <div class="search-input w-100">
          <span class="icon-search"><b-icon-search></b-icon-search></span>
          <b-form-input
            placeholder="SEACH NAME, OWNER"
            type="search"
            id="search-nft"
            v-model="search"
            v-on:change="handleSearch()"
          ></b-form-input>
        </div>
        <div class="w-100 d-flex flex-row">
          <b-form-select
            class="sort w-100"
            v-model="selected"
            :options="options"
            @change="handleSort()"
            plain
          >
          </b-form-select>
          <div
            class="d-flex ml-2 border rounded px-2 justify-content-center align-items-center sort-type align-self-center"
            @click.prevent="handleSort(orSelected)"
          >
            <b-icon
              class="ic-sort"
              :icon="`sort-${orSelected === 'L2H' ? 'up' : 'down'}`"
              variant="light"
            ></b-icon>
          </div>
        </div>
      </div>
      <div class="icon-position">
        <div class="is-flex space-between grid-layout">
          <b-input-group-text
            v-on:click="onClzActive('columns-3')"
            :class="activeLayout === 'columns-3' ? 'active' : ''"
          >
            <b-icon-grid-fill></b-icon-grid-fill>
          </b-input-group-text>
          <b-input-group-text
            v-on:click="onClzActive('columns-4')"
            :class="activeLayout === 'columns-4' ? 'active' : ''"
          >
            <b-icon-grid3x3-gap-fill></b-icon-grid3x3-gap-fill>
          </b-input-group-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavFilter",
  props: ["clzLayout", "pSearch"],
  data: () => ({
    myType: "scholarNft",
    search: "",
    show: false,
    oNfts: [
      { value: "yourNft", text: "My Nft" },
      { value: "scholarNft", text: "Scholarship" },
    ],
    sNft: [
      { value: "scholarNft", text: "Scholarship" },
      { value: "yourNft", text: "My Nfts" },
    ],
    options: [
      { value: "id", text: "ID" },
      { value: "rate", text: "Rate" },
      {
        label: "Battle Power",
        options: [
          { value: "stats.power.total", text: "Total" },
          { value: "stats.power.slash", text: "Slash" },
          { value: "stats.power.heavy", text: "Heavy" },
          { value: "stats.power.strike", text: "Strike" },
          { value: "stats.power.tech", text: "Tech" },
          { value: "stats.power.magic", text: "Magic" },
        ],
      },
      {
        label: "Battle Attack",
        options: [
          { value: "stats.attack.slash", text: "Slash" },
          { value: "stats.attack.heavy", text: "Heavy" },
          { value: "stats.attack.strike", text: "Strike" },
          { value: "stats.attack.tech", text: "Tech" },
          { value: "stats.attack.magic", text: "Magic" },
        ],
      },
      {
        label: "Battle Defend",
        options: [
          { value: "stats.defend.slash", text: "Slash" },
          { value: "stats.defend.heavy", text: "Heavy" },
          { value: "stats.defend.strike", text: "Strike" },
          { value: "stats.defend.tech", text: "Tech" },
          { value: "stats.defend.magic", text: "Magic" },
        ],
      },
    ],
    selected: "rate",
    orSelected: "H2L",
    activeLayout: "columns-4",
    oNftType: {},
  }),
  created() {
    this.onClzActive(this.clzLayout || "columns-4");
  },
  methods: {
    onClzActive(clzLayout) {
      if (this.pSearch) {
        this.search = this.pSearch.search || "";
        this.selected = this.pSearch.selected || "R";
        this.orSelected = this.pSearch.orSelected || "H2L";
      }
      this.activeLayout = clzLayout;
      this.$emit("onLayoutChange", this.activeLayout);
    },
    handleSort(sortType) {
      if (sortType) {
        this.orSelected = sortType === "L2H" ? "H2L" : "L2H";
      }
      this.handleSearch();
    },
    onApply() {
      this.show = false;
      const params = {
        search: this.search,
        selected: this.selected,
        orSelected: this.orSelected,
        myType: this.myType,
      };
      this.$emit("onApply", params);
    },
    handleSearch() {
      this.$emit("onSearch", {
        search: this.search,
        selected: this.selected,
        orSelected: this.orSelected,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mfilter-wrap {
  position: relative;
  .filter-left {
    width: calc(100% - 145px);
    display: flex;
    gap: 16px;
    .group-filter {
      width: 80%;
      flex-wrap: nowrap;
    }
    .b-skeleton-input {
      border: none;
    }
    .custom-sekeleton-input {
      padding: 6px 12px;
      border: 1px solid #434048;
      border-radius: 8px;
      &.search-input {
        width: 45%;
      }
      &.select-input {
        width: 35%;
      }
    }
    .filter-button {
      display: none;
      background-color: transparent;
      color: inherit;
      border-color: #434048;
      border-radius: 8px;
      min-height: 56px;
      min-width: 120px !important;
      font-weight: 600;
      &:focus {
        box-shadow: none;
      }
      &:not(:disabled):not(.disabled):active:focus {
        box-shadow: none;
        background-color: #14101a;
        border-color: #434048;
        color: inherit;
      }
    }

    .filter-left {
      #sb-filter {
        background-image: linear-gradient(180deg, #030204, rgba(70, 50, 100, 0)),
          linear-gradient(0deg, #433060, #433060);
        font-family: "Source Sans Pro", sans-serif;
        .sb-body {
          color: #ffffff;
          font-family: "Source Sans Pro", sans-serif;
        }
      }
    }
    .search-input {
      position: relative;
      width: 50%;
    }
    .icon-search {
      position: absolute;
      left: 18px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 20px;
      z-index: 5;
    }

    .sort-type {
      height: 56px;
      background-color: transparent;
      color: inherit;
      border: 1px solid #434048 !important;
      border-radius: 8px;
      cursor: pointer;
      margin-bottom: 0;
      .ic-sort {
        font-size: 1.75em;
      }
    }

    #search-nft {
      height: 56px;
      border-radius: 8px;
      padding-left: 45px;
      background-color: transparent;
      border-color: #434048;
      color: #fff;
      font-weight: 600;
      &::-webkit-input-placeholder {
        /* Edge */
        color: #fff;
        font-weight: 600;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer */
        color: #fff;
        font-weight: 600;
      }

      &::placeholder {
        color: #fff;
        font-weight: 600;
      }
    }
    .sort {
      height: 56px;
      border-radius: 8px;
      width: 35%;
      background-color: transparent;
      border-color: #434048;
      color: #fff;
      text-transform: uppercase;
      font-weight: 600;
      option {
        cursor: pointer;
        background: #20132f;
        &:hover {
          background-color: #482f66;
        }
      }
      optgroup {
        background: #20132f;
      }
    }
  }

  .icon-position {
    position: absolute;
    right: 0;
    top: 0;
  }
  .grid-layout {
    justify-content: center;
    width: 120px;
    .input-group-text {
      height: 56px;
      width: 56px;
      border-radius: 0;
      background-color: transparent;
      justify-content: center;
      cursor: pointer;
      color: #fff;
      border-color: #434048;
      &:first-child {
        border-right: 0;
      }
      &.active {
        background-image: linear-gradient(0deg, #503161, rgba(70, 50, 100, 0)),
          linear-gradient(180deg, #eb345f, #eb345f);
      }
    }
  }
  @media (max-width: 767px) {
    .filter-left {
      flex-direction: column;
      width: 100%;
      .search-input {
        width: 100% !important;
      }

      .filter-button {
        max-width: 150px;
      }
    }
    .icon-position {
      display: none;
    }
  }
}
</style>
